(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "./components", "./hooks"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("./components"), require("./hooks"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.components, global.hooks);
    global.index = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _components, _hooks) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  Object.keys(_components).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _components[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _components[key];
      }
    });
  });
  Object.keys(_hooks).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _hooks[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _hooks[key];
      }
    });
  });
});